export default "__VITE_ASSET__BaV$ZiNv__"